"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useTimeout", {
    enumerable: true,
    get: ()=>useTimeout
});
const _interopRequireWildcard = require("@swc/helpers/lib/_interop_require_wildcard.js").default;
const _react = /*#__PURE__*/ _interopRequireWildcard(require("react"));
function useTimeout() {
    const [timeout] = _react.useState(()=>({
            id: undefined,
            set: (fn, delay)=>{
                timeout.clear();
                timeout.id = setTimeout(fn, delay);
            },
            clear: ()=>{
                if (timeout.id !== undefined) {
                    clearTimeout(timeout.id);
                    timeout.id = undefined;
                }
            }
        }));
    // Clean up the timeout when the component is unloaded
    _react.useEffect(()=>timeout.clear, [
        timeout
    ]);
    return [
        timeout.set,
        timeout.clear
    ];
} //# sourceMappingURL=useTimeout.js.map

//# sourceMappingURL=useTimeout.js.map